import DebugHelper from '../helpers/debug-helper.js';

export const adobeAnalytics = {
	getLogger() {
		return new DebugHelper('adobeAnalytics');
	},

	trackEvent(payload, override = false) {
		window.adobeDataLayer = window.adobeDataLayer || [];

		// Find the index of an existing event with the same name
		const existingIndex = window.adobeDataLayer.findIndex(
			(item) => item.event === payload.event,
		);
		if (override && existingIndex !== -1) {
			// If found, replace the existing entry
			window.adobeDataLayer[existingIndex] = payload;
		} else {
			// If not found, add the new entry
			window.adobeDataLayer.push(payload);
		}
	},

	sendSubscriptionState(payload) {
		const event = Object.assign(
			{
				event: 'adobe-subscription-status-change',
				isSubscribed: payload.isSubscribed,
			},
			payload,
		);

		this.trackEvent(event, true);
	},

	sendCheckoutComplete(payload) {
		const event = Object.assign(
			{
				event: 'adobe-conversion-status-change',
				hasConverted: payload.hasConverted,
			},
			payload,
		);

		this.trackEvent(event);
	},

	sendAppCheckoutCompleted(payload) {
		const event = Object.assign(
			{
				event: 'adobe-app-conversion-status-change',
				hasConverted: payload.hasConverted,
			},
			payload,
		);

		this.trackEvent(event);
	},

	sendConversionData(payload) {
		const event = Object.assign(
			{
				event: `adobe-user-conversion-data-${payload.termId}`,
			},
			payload,
		);

		this.trackEvent(event, true);
	},

	sendConversionDataArray(payload) {
		const event = {
			event: 'adobe-user-conversion-data',
			conversionData: payload,
		};

		this.trackEvent(event);
	},

	sendUniqueUserId(payload) {
		const event = Object.assign(
			{
				event: 'adobe-unique-customer-id',
			},
			payload,
		);

		this.trackEvent(event, true);
	},

	sendPianoGeaEvent(eventName, eventNumber) {
		const payload = {
			event: 'adobe-gea-event-fired',
			eventName: eventName,
			eventNumber: eventNumber,
		};

		this.trackEvent(payload);
	},
};
